/**
 * /me/payments/latest — Session 3d PR 7.
 * Owning agent: Khidmat. Detail-card-style page (NOT a list).
 */

import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { ErrorPanel, Loading } from "../components/Loading";
import { session3dApi } from "../lib/session3d-api";
import {
  MeActionsRow,
  MeEmployeeRequiredGate,
  Session3dMeShell,
  useCurrentEmployeeId,
} from "./_session3dShell";

export function MyLatestPayslipPage() {
  const { t } = useTranslation();
  const employeeId = useCurrentEmployeeId();

  const query = useQuery({
    queryKey: ["s3d-latest-payslip", employeeId],
    queryFn: () => session3dApi.getLatestPayslip(employeeId),
    enabled: !!employeeId,
  });

  const data = query.data;

  return (
    <MeEmployeeRequiredGate>
      <Session3dMeShell
        title={t("me.latest-payslip.title", "Latest Payslip")}
        subtitle={t("me.latest-payslip.subtitle", "Your most recent payslip with full line-item breakdown.")}
        briefContext={{
          total: 1,
          attention: 0,
          critical: 0,
          top_kind: t("me.latest-payslip.title", "Latest Payslip"),
          window_label: t("me.latest-payslip.window", "current period"),
        }}
        actionsRow={
          <MeActionsRow
            khidmatPrefill={t("me.latest-payslip.ask_khidmat", "Explain my latest payslip.")}
          />
        }
      >
        {query.isLoading && <Loading />}
        {query.isError && <ErrorPanel message={(query.error as Error).message} />}
        {data && (
          <div className="rounded-2xl border border-border-subtle bg-white p-4 text-sm">
            <p className="text-xs text-text-tertiary">
              {t(
                "me.latest-payslip.detail_note",
                "Latest period payslip: earnings (basic · allowances · OT) + deductions (GOSI · loans · garnishments) + net. Each line is TraceableValue-explainable.",
              )}
            </p>
            <pre className="mt-3 overflow-x-auto rounded bg-surface-sunken p-3 font-mono text-[10px] text-text-secondary">
{JSON.stringify(data, null, 2)}
            </pre>
          </div>
        )}
      </Session3dMeShell>
    </MeEmployeeRequiredGate>
  );
}
